import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback } from 'react';
var useInfoNavigation = function useInfoNavigation(_ref) {
  var tutorialScreens = _ref.tutorialScreens,
    _ref$eventCallback = _ref.eventCallback,
    eventCallback = _ref$eventCallback === void 0 ? function () {} : _ref$eventCallback,
    _ref$closeEventCallba = _ref.closeEventCallback,
    closeEventCallback = _ref$closeEventCallba === void 0 ? function () {} : _ref$closeEventCallba;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openModal = _useState2[0],
    setOpenModal = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    tutorialScreen = _useState4[0],
    setTutorialScreen = _useState4[1];
  var findIndexScreen = function findIndexScreen() {
    return tutorialScreens.findIndex(function (x) {
      return x === tutorialScreen;
    });
  };
  var handleBackScreen = function handleBackScreen() {
    return setTutorialScreen(tutorialScreens[findIndexScreen() - 1]);
  };
  var handleFowardScreen = function handleFowardScreen() {
    return setTutorialScreen(tutorialScreens[findIndexScreen() + 1]);
  };
  var handleOpenModal = useCallback(function () {
    eventCallback === null || eventCallback === void 0 || eventCallback();
    setTutorialScreen(tutorialScreens[0]);
    setOpenModal(true);
  }, [eventCallback, tutorialScreens]);
  var handleCloseModal = useCallback(function () {
    closeEventCallback === null || closeEventCallback === void 0 || closeEventCallback();
    setOpenModal(false);
  }, [closeEventCallback]);
  return {
    openModal: openModal,
    setOpenModal: setOpenModal,
    handleOpenModal: handleOpenModal,
    handleCloseModal: handleCloseModal,
    tutorialScreen: tutorialScreen,
    findIndexScreen: findIndexScreen,
    handleBackScreen: handleBackScreen,
    handleFowardScreen: handleFowardScreen
  };
};
export default useInfoNavigation;